// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IProcessEnrollmentRequestDto
 */
export interface IProcessEnrollmentRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IProcessEnrollmentRequestDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IProcessEnrollmentRequestDto
     */
    plan_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IProcessEnrollmentRequestDto
     */
    health_plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IProcessEnrollmentRequestDto
     */
    enrollment_status?: IProcessEnrollmentRequestDtoEnrollmentStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IProcessEnrollmentRequestDto
     */
    effective_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IProcessEnrollmentRequestDto
     */
    election_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IProcessEnrollmentRequestDto
     */
    deductible_met?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof IProcessEnrollmentRequestDto
     */
    deductible_met_date?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IProcessEnrollmentRequestDto
     */
    limited_use?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IProcessEnrollmentRequestDto
     */
    per_pay_employer?: number;
    /**
     * 
     * @type {number}
     * @memberof IProcessEnrollmentRequestDto
     */
    per_pay_employee?: number;
    /**
     * 
     * @type {string}
     * @memberof IProcessEnrollmentRequestDto
     */
    coverage_tier?: string;
    /**
     * 
     * @type {Date}
     * @memberof IProcessEnrollmentRequestDto
     */
    coverage_tier_effective_date?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IProcessEnrollmentRequestDtoEnrollmentStatusEnum {
    A = 'A',
    C = 'C'
}


/**
 * Check if a given object implements the IProcessEnrollmentRequestDto interface.
 */
export function instanceOfIProcessEnrollmentRequestDto(value: object): value is IProcessEnrollmentRequestDto {
    return true;
}

export function IProcessEnrollmentRequestDtoFromJSON(json: any): IProcessEnrollmentRequestDto {
    return IProcessEnrollmentRequestDtoFromJSONTyped(json, false);
}

export function IProcessEnrollmentRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProcessEnrollmentRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'health_plan_id': json['health_plan_id'] == null ? undefined : json['health_plan_id'],
        'enrollment_status': json['enrollment_status'] == null ? undefined : json['enrollment_status'],
        'effective_date': json['effective_date'] == null ? undefined : (new Date(json['effective_date'])),
        'election_amount': json['election_amount'] == null ? undefined : json['election_amount'],
        'deductible_met': json['deductible_met'] == null ? undefined : json['deductible_met'],
        'deductible_met_date': json['deductible_met_date'] == null ? undefined : (new Date(json['deductible_met_date'])),
        'limited_use': json['limited_use'] == null ? undefined : json['limited_use'],
        'per_pay_employer': json['per_pay_employer'] == null ? undefined : json['per_pay_employer'],
        'per_pay_employee': json['per_pay_employee'] == null ? undefined : json['per_pay_employee'],
        'coverage_tier': json['coverage_tier'] == null ? undefined : json['coverage_tier'],
        'coverage_tier_effective_date': json['coverage_tier_effective_date'] == null ? undefined : (new Date(json['coverage_tier_effective_date'])),
    };
}

export function IProcessEnrollmentRequestDtoToJSON(json: any): IProcessEnrollmentRequestDto {
    return IProcessEnrollmentRequestDtoToJSONTyped(json, false);
}

export function IProcessEnrollmentRequestDtoToJSONTyped(value?: IProcessEnrollmentRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'plan_id': value['plan_id'],
        'health_plan_id': value['health_plan_id'],
        'enrollment_status': value['enrollment_status'],
        'effective_date': value['effective_date'] == null ? undefined : ((value['effective_date']).toISOString().substring(0,10)),
        'election_amount': value['election_amount'],
        'deductible_met': value['deductible_met'],
        'deductible_met_date': value['deductible_met_date'] == null ? undefined : ((value['deductible_met_date']).toISOString().substring(0,10)),
        'limited_use': value['limited_use'],
        'per_pay_employer': value['per_pay_employer'],
        'per_pay_employee': value['per_pay_employee'],
        'coverage_tier': value['coverage_tier'],
        'coverage_tier_effective_date': value['coverage_tier_effective_date'] == null ? undefined : ((value['coverage_tier_effective_date']).toISOString().substring(0,10)),
    };
}

